"use client"

import { AppLayout } from '@sourcepilot/ui/framework/ui/views';
import { UnconfirmedNotice } from '@sourcepilot/ui/framework/ui/molecules/UnconfirmedNotice';
// Side-effect import: registers per-model field-renderer overrides
// (e.g. `AttributeValueValueEditor` for `AttributeValue.value`) on the
// framework's Jotai store so `ModelDetailView` everywhere picks them up.
import '@/config/field-overrides';
// Side-effect import: registers the standalone "add to chat context"
// button so `ModelDetailView` renders it in every entity detail header
// (gives RFLP entities the add-to-context affordance PDM layouts have).
import '@/config/add-to-context-button';

/**
 * Main route group layout.
 *
 * Wraps all non-login routes in AppLayout, which handles:
 * - Shell toggle (?shell=true/false, with app default from config/app.ts)
 * - Auth check (shell requires auth; private models require auth)
 *
 * Individual model routes can override publicRoute for public types.
 * Login routes live outside this group and have no AppLayout.
 */
export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // a page drawn from the browser's store whose open has not answered says
  // so (client caching stage 2)
  return <AppLayout>{children}<UnconfirmedNotice /></AppLayout>;
}
